/**
 * ErrorCorrectLevel
 *
 * @author Kazuhiko Arase
 */
export var ErrorCorrectLevel;
(function (ErrorCorrectLevel) {
    /**
     * 7%
     */
    ErrorCorrectLevel[ErrorCorrectLevel["L"] = 1] = "L";
    /**
     * 15%
     */
    ErrorCorrectLevel[ErrorCorrectLevel["M"] = 0] = "M";
    /**
     * 25%
     */
    ErrorCorrectLevel[ErrorCorrectLevel["Q"] = 3] = "Q";
    /**
     * 30%
     */
    ErrorCorrectLevel[ErrorCorrectLevel["H"] = 2] = "H";
})(ErrorCorrectLevel || (ErrorCorrectLevel = {}));
//# sourceMappingURL=ErrorCorrectLevel.js.map